import { render, staticRenderFns } from "./ModalMensagemConfirmarEmail.vue?vue&type=template&id=5989f4e4&scoped=true&"
import script from "./ModalMensagemConfirmarEmail.vue?vue&type=script&lang=js&"
export * from "./ModalMensagemConfirmarEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalMensagemConfirmarEmail.vue?vue&type=style&index=0&id=5989f4e4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989f4e4",
  null
  
)

export default component.exports